/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
import { useHasPermission } from "../../hooks/useHasPermission";

/* Components */
import UCButton from "../../components/buttons";
import CreatePolicyModal from "../../components/modals/createPolicyModal";

/* Styles */
import styles from "./styles.js";

const PolicyPageHeader = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const [showCreatePolicyModal, setShowCreatePolicyModal] = useState(false);
  const { checkPermission } = useHasPermission();

  const createPolicy = () => {
    setShowCreatePolicyModal(true)
  }

  return (
    <div className={classes.pageHeader}>
      <Container className={classes.container}>
        <Row>
          <Col xs={12} sm={8} className="gx-0">
            <h1 className={classes.title}>
              <FormattedMessage id="policy.title" />
            </h1>
            <h3 className={classes.subtitle}>
              <FormattedMessage id="policy.subtitle" />
            </h3>
          </Col>
          <Col xs={12} sm={4} className={classes.btnWrapper}>
          { 
            (checkPermission("F_ADD_POLICY")) &&
            <UCButton
              type="primary"
              className={classes.addBtn}
              onClick={() => createPolicy()}
              text={<FormattedMessage id="policy.addBtn" />}
            />
          }
          </Col>
        </Row>
        <CreatePolicyModal 
          showCreatePolicyModal={showCreatePolicyModal}
          setShowCreatePolicyModal={setShowCreatePolicyModal}
        />
      </Container>
    </div>
  );
};

export default PolicyPageHeader;